import React from "react";
import { CreditCard } from "lucide-react";
import { PrivyCardOnrampButton } from "../../components/transfer/PrivyCardOnrampButton";

export function CardFundingCard({
  transferId,
}) {
  if (!transferId) {
    return null;
  }

  return (
    <div className="w-full max-w-[430px] rounded-3xl border border-[#0A4730]/10 bg-white p-5 shadow-[0_8px_30px_rgba(10,71,48,0.07)]">
      <div className="mb-4 flex items-start gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#C0F6B7]/50 text-[#0A4730]">
          <CreditCard size={18} />
        </div>

        <div>
          <p className="text-sm font-semibold text-[#0A4730]">
            Pay by card
          </p>

          <p className="mt-1 text-xs leading-5 text-[#0A2540]/50">
            Continue securely to complete your
            card payment.
          </p>
        </div>
      </div>

      <PrivyCardOnrampButton
        transferId={transferId}
      />
    </div>
  );
}